import React from "react";
import {useLocation, useNavigate} from "react-router-dom";
import useDynamicColors from "../../../../../hooks/useDynamicColors";
import "./style.css";
import welcomeimg from "url:../../../../../assets/img/welcomemyoung.png";


export const MiddleYoungOnboardingWelcome = () => {
  const colors = useDynamicColors();
  const location = useLocation();
  const navigate = useNavigate();

  const handleButtonClick = () => {
    const currentParams = location.search;
    navigate(`/sport-landing-MIDDLEYOUNG-mobile${currentParams}`);
  };

  const handleButtonAdelante = () => {
    const currentParams = location.search;
    navigate(`/sport-onboarding-steppper${currentParams}`);
  };

  return (
      <div className="young-onboarding-screen-welcome">
        <div className="young-onboarding-2">
          <div className="overlap-group-2">
            {/* <div className="content-wrapper">
            <div className="content-3">
              <div className="text-wrapper-6">9:50</div>

              <img className="img" alt="Icons" src="/img/icons-6.svg" />
            </div>
          </div> */}


            <img
                className="group"
                alt="Group"
                src={welcomeimg}

                style={{width:150,objectFit:'contain',maxHeight:200}}
            />
          </div>
         

          <p className="pay-for-your-favorit">
            <b>Your account has been opened</b> <br /> <br /><br /> <br /> <br />
            Enjoy all the benefits of our App
          </p>

          <div className="payment-worldwide">Welcome Soan!</div>
          <div className="test-button-wrapper">
            <div
                className="test-button-2 highlighted-button"
                onClick={handleButtonClick}
                style={{ borderRadius: 12, width: "100%" }}
            >
              <div className="text-wrapper-5">Let’s start!</div>
            </div>
          </div>
        </div>
      </div>
  );
};
